import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Util from 'root/module/util';
import Cache from 'root/cache';
import Modals from 'root/modals';
import Constants from 'root/constants';
import View from 'view/base';
import Form from 'root/module/form';
import {loadSurveys} from 'root/service/survey';
import Collection_Survey from 'collection/survey';

export default View.extend({
    confirmation_is_disabled: true,
    confirmation_email_subject: '',
    confirmation_email_html: '',
    confirmation_feedback_type: [],

    events: {
        'input input[name="email_subject"]'    : 'onConfirmationChange',
        'input textarea[name="email_html"]'    : 'onConfirmationChange',
        'input textarea[name="content"]'       : 'onConfirmationChange',
        'change input[name="feedback_type"]'   : 'onConfirmationChange',
        'click .feedback-confirmation-preview' : 'onPreviewConfirmationEmail',
        'click .wildcard-text'                 : 'onClickWildcardText',
        'submit .confirmation-form'            : 'onConfirmationFormSubmit',
        'click .dropdown-survey li'            : 'onSelectSurvey'
    },

    dom_handlers: {
        onConfirmationChange: function(e) {
            this.checkConfirmationChanges();
        },

        onPreviewConfirmationEmail: function(e) {
            e.preventDefault();

            var form_data = Form.getData(this.$el.find('.confirmation-form'));

            if (this.type === 'confirmation_email') {
                Modals.previewConfirmationEmail(form_data.email_html);
            } else {
                Modals.previewAutoreplyEmail(form_data.content);
            }
        },

        onClickWildcardText: function(e) {
            var target_value = $(e.currentTarget).text();

            var selector = this.type === 'confirmation_email' ? 'email_html' : 'content';
            var textarea = this.$el.find('.confirmation-form textarea[name="' + selector + '"]');

            var start = textarea.get(0).selectionStart;
            var end = textarea.get(0).selectionEnd;

            var segments = textarea.val().split('');

            segments.splice(start, end - start, target_value)

            var value = segments.join('');

            textarea.val(value);

            this.checkConfirmationChanges();
        },

        onSelectSurvey: function(e) {
            var survey_key = $(e.currentTarget).data('id');

            var textarea = this.$el.find('.confirmation-form textarea');
            var segments = textarea.val().split('');

            var start = textarea.get(0).selectionStart;
            var end = textarea.get(0).selectionEnd;

            var survey = this.survey.findWhere({survey_key: survey_key});
            var survey_link = '[' + survey.getShareUrl() + '](' + survey.getShareUrl() + ')';

            segments.splice(start, end - start, survey_link);

            var value = segments.join('');

            textarea.val(value);

            this.checkConfirmationChanges();
        },

        onConfirmationFormSubmit: function(e) {
            e.preventDefault();

            var form_data = Form.getData(this.$el.find('.confirmation-form'));

            this.$el.find('.confirmation-form').find('button:submit').addClass('loading').prop('disabled', true);

            if (this.type === 'confirmation_email') {
                Cache.app.request({
                    action: 'feedback\\Confirmation/save',
                    data:{...form_data,
                        id: this.data.id,
                        email_html: form_data.email_html,
                        email_subject: form_data.email_subject,
                        feedback_type: form_data.feedback_type,
                        is_disabled: this.data.get('is_disabled'),
                    },
                    success: (response) => {
                        this.data.set(response);
                        this.trigger('Submit:Success');
                    },
                    complete: () => {
                        this.$el.find('.confirmation-form').find('button:submit').removeClass('loading').prop('disabled', false);
                    }
                });
            } else {
                Cache.app.request({
                    action: 'feedback\\Autoreply/update',
                    data:{...form_data,
                        id: this.data ? this.data.id : 0,
                        content: form_data.content,
                        feedback_type: form_data.feedback_type,
                        is_disabled: this.data ? this.data.get('is_disabled') : true,
                    },
                    success: (response) => {
                        if (!this.data) {
                            Cache.feedback_autoreply.add(response);
                            this.data = Cache.feedback_autoreply.findWhere({project_id: response.project_id});
                        } else {
                            this.data.set(response);
                        }

                        this.trigger('Submit:Success');
                    },
                    complete: () => {
                        this.$el.find('.confirmation-form').find('button:submit').removeClass('loading').prop('disabled', false);
                    }
                });
            }
        }
    },

    event_handlers: {
        updateSurveyOptions: function() {
            this.$el.find('.survey-dropdown-list').html(this.renderSurveyDropdown());
        }
    },

    initialize: function(options) {
        this.type = options.type;

        if (this.type === 'confirmation_email') {
            this.data = Cache.feedback_confirmation.findWhere({project_id: options.project_id});
        } else {
            this.data = Cache.feedback_autoreply.findWhere({project_id: options.project_id});
        }

        this.survey = new Collection_Survey();

        this.listenTo(this.survey, 'reset', this.event_handlers.updateSurveyOptions);
    },

    checkConfirmationChanges: function() {
        var has_changed = false;

        if (!has_changed) {
            var is_disabled = this.$el.find('.confirmation-is-disabled').hasClass('switch-off');
            var current_is_disabled = this.data ? this.data.get('is_disabled') : true;

            if (is_disabled !== current_is_disabled) {
                has_changed = true;
            }
        }

        if (!has_changed) {
            var email_subject = Form.getData(this.$el.find('.confirmation-form'))['email_subject'];
            var current_email_subject = this.data ? this.data.get('email_subject') : '';

            if (email_subject !== current_email_subject) {
                has_changed = true;
            }
        }

        if (!has_changed) {
            var email_html = Form.getData(this.$el.find('.confirmation-form'))['email_html'];
            var current_email_html = this.data ? this.data.get('email_html') : '';

            if (email_html !== current_email_html) {
                has_changed = true;
            }
        }

        if (!has_changed) {
            var feedback_type = Form.getData(this.$el.find('.confirmation-form'))['feedback_type'];
            var current_feedback_type = this.data ? this.data.get('feedback_type') : '';
            if (
                _.difference(feedback_type, current_feedback_type.split(',')).length ||
                _.difference(current_feedback_type.split(','), feedback_type).length
            ) {
                has_changed = true;
            }
        }
        this.$el.find('.confirmation-form button.submit').prop('disabled', !has_changed);
    },

    getAssigneeDropdown: function(assignee_type) {
        var setting_name  = 'default_assignee_id_' + assignee_type;
        var selected_user = Cache.user.get(this.model.get(setting_name));
        var all_users     = Cache.app.getUsersByProject(this.model.id, [Constants.ADMIN, Constants.ASSIGNEE]);

        var user_options = '<li data-id="0"' + (selected_user ? '' : ' class="selected"') + '><div class="user-24">?</div>Unassigned</li>';

        all_users.forEach((user) => {
            user_options +=
            '<li data-id="' + user.id + '"' + (user.id === this.model.get(setting_name) ? ' class="selected"' : '') + '>' +
                '<img class="user-24" src="' + user.getAvatar(24) + '">' + user.escape('name') +
            '</li>';
        });

        var html =
        '<div class="button-dropdown button-dropdown-large" data-append="true">' +
            '<button type="button" class="dropdown-select">' +
                (selected_user ?
                '<img class="icon-img icon-img-round" src="' + selected_user.getAvatar() + '">' + selected_user.escape('name') :
                'Unassigned') +
            '</button>' +
            '<div>' +
                (all_users.length > 10 ?
                '<div class="dropdown-search"><input type="text" class="solid compact" placeholder="Search user"></div>' : '') +
                '<ul class="dropdown dropdown-select dropdown-user" data-val="' + assignee_type + '">' + user_options + '</ul>' +
            '</div>' +
        '</div>';

        return html;
    },

    renderEmailConfirmation: function() {
        var content = '<form class="confirmation-form form-fluid">' +
            '<div class="row">' +
                '<div class="field-label">Select feedback type</div>' +
                '<div>' +
                    '<input type="checkbox" name="feedback_type" id="feedback_type_bug" value="' + Constants.FEEDBACK_BUG + '"><label for="feedback_type_bug">Bug</label>' +
                    '<input type="checkbox" name="feedback_type" id="feedback_type_feature_request" value="' + Constants.FEEDBACK_FEATURE_REQUEST + '"><label for="feedback_type_feature_request">Idea</label>' +
                    '<input type="checkbox" name="feedback_type" id="feedback_type_general" value="' + Constants.FEEDBACK_GENERAL + '"><label for="feedback_type_general">General Feedback</label>' +
                '</div>' +
            '</div>' +
            '<div class="row">' +
                '<div class="field-label">Subject</div>' +
                '<input class="solid medium" name="email_subject" type="text" data-nonempty="true" required></input>' +
            '</div>' +
            '<div class="row">' +
                '<div class="field-label">Message</div>' +
                '<div class="position-relative">' +
                    '<textarea class="solid compact white" name="email_html" rows="10" placeholder="" data-nonempty="true" required></textarea>' +
                    '<div class="text-inline-help"><i class="info fas fa-question-circle"></i><div>You can use markdown syntax to add links.<br><br>For example:<br><span class="font-weight-medium">[Visit our website](https://www.example.com)</span><br><span class="font-weight-medium">[Contact us](mailto:help@example.com)</span></div></div>' +
                '</div>' +
                '<div class="margin-top-12">' +
                    '<a href="#" class="feedback-confirmation-preview float-right text-medium text-primary"><i class="fa-solid fa-eye margin-right-4"></i>Preview</a>' +
                    '<span class="wildcard-text text-primary text-small tooltip cursor-pointer margin-right-12" data-title="Placeholder: Reporter Name">%%reporter_name%%</span>' +
                    '<span class="wildcard-text text-primary text-small tooltip cursor-pointer margin-right-12"  data-title="Placeholder: Feedback Link">%%feedback_link%%</span>' +
                    '<span class="survey-dropdown-list">' + this.renderSurveyDropdown() + '</span>' +
                '</div>' +
            '</div>' +
            '<div class="text-align-right">' +
                '<button class="primary submit medium" type="submit" disabled>Save Changes</button>' +
            '</div>' +
        '</form>';

        this.$el.html(content);

        Form.setData(this.$el.find('.confirmation-form'), {
            email_subject : this.data.get('email_subject'),
            email_html    : this.data.get('email_html'),
            feedback_type : this.data.get('feedback_type').split(',')
        });
    },

    renderSurveyDropdown: function() {
        var survey_options = '';

        this.survey.sortSurveyByStatus().forEach((survey) => {
            const project_name = Cache.project.get(survey.get('project_id')).get('name');
            const status = survey.getStatus();
            const status_text = Util.cap(survey.getStatus())
            survey_options +=
            '<li data-id="' + survey.get('survey_key') + '">' +
                '<span class="status-indicator tooltip" data-status="' + status + '" data-title="' + status_text + '"></span>' +
                Util.htmlEntities(project_name) +
            '</li>';
        });

        if (!survey_options) {
            survey_options = '<li class="disabled">No surveys found</li>';
        }

        var html =
        '<div class="button-dropdown button-dropdown-large" data-append="true">' +
            '<button type="button" class="wildcard-text-survey text-primary text-small tooltip cursor-pointer">' +
                '%%survey_link%%' +
            '</button>' +
            '<div>' +
                '<ul class="dropdown dropdown-survey" data-val="">' + survey_options + '</ul>' +
            '</div>' +
        '</div>';

        return html;
    },

    renderAutoReply: function() {
        var content = '<form class="confirmation-form form-fluid">' +
            '<div class="row">' +
                '<div class="field-label">Select feedback type</div>' +
                '<div>' +
                    '<input type="checkbox" name="feedback_type" id="feedback_type_bug" value="' + Constants.FEEDBACK_BUG + '"><label for="feedback_type_bug">Bug</label>' +
                    '<input type="checkbox" name="feedback_type" id="feedback_type_feature_request" value="' + Constants.FEEDBACK_FEATURE_REQUEST + '"><label for="feedback_type_feature_request">Idea</label>' +
                    '<input type="checkbox" name="feedback_type" id="feedback_type_general" value="' + Constants.FEEDBACK_GENERAL + '"><label for="feedback_type_general">General Feedback</label>' +
                '</div>' +
            '</div>' +
            '<div class="row">' +
                '<div class="field-label">Message</div>' +
                '<div class="position-relative">' +
                    '<textarea class="solid compact white" name="content" rows="10" placeholder="" data-nonempty="true" required></textarea>' +
                    '<div class="text-inline-help"><i class="info fas fa-question-circle"></i><div>You can use markdown syntax to add links.<br><br>For example:<br><span class="font-weight-medium">[Visit our website](https://www.example.com)</span><br><span class="font-weight-medium">[Contact us](mailto:help@example.com)</span></div></div>' +
                '</div>' +
                '<div class="margin-top-12">' +
                    '<a href="#" class="feedback-confirmation-preview float-right text-medium text-primary"><i class="fa-solid fa-eye margin-right-4"></i>Preview</a>' +
                    '<span class="wildcard-text text-primary text-small tooltip cursor-pointer margin-right-12" data-title="Placeholder: Reporter Name">%%reporter_name%%</span>' +
                    '<span class="wildcard-text text-primary text-small tooltip cursor-pointer margin-right-12"  data-title="Placeholder: Feedback Link">%%feedback_link%%</span>' +
                    '<span class="survey-dropdown-list">' + this.renderSurveyDropdown() + '</span>' +
                '</div>' +
            '</div>' +
            '<div class="text-align-right">' +
                '<button class="primary submit medium" type="submit" disabled>Save Changes</button>' +
            '</div>' +
        '</form>';

        this.$el.html(content);

        Form.setData(this.$el.find('.confirmation-form'), {
            content : this.data ? this.data.get('content') : '',
            feedback_type : this.data ? this.data.get('feedback_type').split(',') : []
        });
    },

    render: function() {
        if (this.type === 'confirmation_email') {
            this.renderEmailConfirmation();
        } else {
            this.renderAutoReply();
        }

        if (!this.survey.isLoaded()) {
            this.survey.markAsLoaded();
            loadSurveys((response) => {
                this.survey.reset(response);
            });
        }

        return this;
    }
});
